module.exports = __webpack_public_path__ + "static/img/map-mask-au.6d28cf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/page-home/Background/images/map-mask-au.jpg
// module id = 826
// module chunks = 0